import {
    FETCH_LANGUAGE_DATA_REQUEST,
    FETCH_LANGUAGE_DATA_SUCCESS,
    FETCH_LANGUAGE_DATA_FAILURE,
    UPLOAD_LANGUAGE_FILE_START,
    UPLOAD_LANGUAGE_FILE_PROGRESS,
    UPLOAD_LANGUAGE_FILE_SUCCESS,
    UPLOAD_LANGUAGE_FILE_FAILURE,
    UPLOAD_LANGUAGE_FILE_CANCEL,
    IMPORT_LANGUAGE_DATA_REQUEST,
    IMPORT_LANGUAGE_DATA_SUCCESS,
    IMPORT_LANGUAGE_DATA_FAILURE,
    UPDATE_LANGUAGE_SELECTION,
    DOWNLOAD_TEMPLATE_REQUEST,
    TOGGLE_DOWNLOAD_SECTION,
    DOWNLOAD_TEMPLATE_SUCCESS,
    DOWNLOAD_TEMPLATE_FAILURE,
    RESET_LANGUAGE_DIALOG_STATE,
    SET_FILE_FORMAT,
    REMOVE_UPLOADED_FILE,
    SHOW_CONFIRMATION_DIALOG,
    HIDE_CONFIRMATION_DIALOG,
    SET_PENDING_SELECTION,
    SET_INITIAL_SELECTION,
} from './AddLanguageDialogTypes';

const initialState = {
    languageData: [],
    languageLoading: false,
    languageError: null,
    uploadedFile: null,
    uploadProgress: 0,
    isUploading: false,
    parsedData: null,
    uploadError: null,
    fileFormat: '',
    showDownloadSection: false,
    downloadLoading: false,
    downloadError: null,
    selectedLanguages: [],
    importLoading: false,
    importSuccess: false,
    importError: null,
    initialSelectedLanguages: [],
    showConfirmationDialog: false,
    languagesToRemove: [],
    pendingSelection: null,
};

const addLanguageDialogReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LANGUAGE_DATA_REQUEST:
            return {
                ...state,
                languageLoading: true,
                languageError: null,
            };

        case FETCH_LANGUAGE_DATA_SUCCESS:
            return {
                ...state,
                languageLoading: false,
                languageData: action.payload,
                languageError: null,
            };

        case FETCH_LANGUAGE_DATA_FAILURE:
            return {
                ...state,
                languageLoading: false,
                languageError: action.payload,
            };

        case UPLOAD_LANGUAGE_FILE_START:
            return {
                ...state,
                uploadedFile: action.payload,
                isUploading: true,
                uploadProgress: 0,
                parsedData: null,
                uploadError: null,
            };

        case UPLOAD_LANGUAGE_FILE_PROGRESS:
            return {
                ...state,
                uploadProgress: action.payload,
            };

        case UPLOAD_LANGUAGE_FILE_SUCCESS:
            return {
                ...state,
                uploadedFile: action.payload.file,
                parsedData: action.payload.parsedData,
                isUploading: false,
                uploadProgress: 100,
                uploadError: null,
            };

        case UPLOAD_LANGUAGE_FILE_FAILURE:
            return {
                ...state,
                isUploading: false,
                uploadProgress: 0,
                uploadError: action.payload,
                parsedData: null,
            };

        case UPLOAD_LANGUAGE_FILE_CANCEL:
            return {
                ...state,
                isUploading: false,
                uploadProgress: 0,
                uploadedFile: null,
                parsedData: null,
                uploadError: null,
            };

        case REMOVE_UPLOADED_FILE:
            return {
                ...state,
                uploadedFile: null,
                uploadProgress: 0,
                isUploading: false,
                parsedData: null,
                uploadError: null,
            };

        case IMPORT_LANGUAGE_DATA_REQUEST:
            return {
                ...state,
                importLoading: true,
                importSuccess: false,
                importError: null,
            };

        case IMPORT_LANGUAGE_DATA_SUCCESS:
            return {
                ...state,
                importLoading: false,
                importSuccess: true,
                importError: null,
                uploadedFile: null,
                uploadProgress: 0,
                parsedData: null,
            };

        case IMPORT_LANGUAGE_DATA_FAILURE:
            return {
                ...state,
                importLoading: false,
                importSuccess: false,
                importError: action.payload,
            };

        case UPDATE_LANGUAGE_SELECTION:
            return {
                ...state,
                selectedLanguages: action.payload,
            };

        case SET_INITIAL_SELECTION:
            return {
                ...state,
                initialSelectedLanguages: action.payload,
                selectedLanguages: action.payload,
            }

        case DOWNLOAD_TEMPLATE_REQUEST:
            return {
                ...state,
                downloadLoading: true,
                downloadError: null,
            };

        case TOGGLE_DOWNLOAD_SECTION:
            return {
                ...state,
                showDownloadSection: action.payload,
            };

        case DOWNLOAD_TEMPLATE_SUCCESS:
            return {
                ...state,
                downloadLoading: false,
                downloadError: null,
            };

        case DOWNLOAD_TEMPLATE_FAILURE:
            return {
                ...state,
                downloadLoading: false,
                downloadError: action.payload,
            };

        case SET_FILE_FORMAT:
            return {
                ...state,
                fileFormat: action.payload,
            };

        case RESET_LANGUAGE_DIALOG_STATE:
            return {
                ...state,
                selectedLanguages: [],
                initialSelectedLanguages: [],
                showConfirmationDialog: false,
                languagesToRemove: [],
                pendingSelection: null,
                uploadedFile: null,
                uploadProgress: 0,
                isUploading: false,
                parsedData: null,
                uploadError: null,
                showDownloadSection: false,
                fileFormat: '',
                importSuccess: false,
                importLoading: false,
                importError: null,
            };
        case SHOW_CONFIRMATION_DIALOG:
            return {
                ...state,
                showConfirmationDialog: true,
                languagesToRemove: action.payload.languagesToRemove,
                pendingSelection: action.payload.pendingSelection,
                errorMessage: action.payload.errorMessage || null,
            };

        case HIDE_CONFIRMATION_DIALOG:
            return {
                ...state,
                showConfirmationDialog: false,
                languagesToRemove: [],
                pendingSelection: null,
            };

        case SET_PENDING_SELECTION:
            return {
                ...state,
                pendingSelection: action.payload,
            };

        default:
            return state;
    }
};

export default addLanguageDialogReducer;